export default {
  receiving_object: '选择标签',
  receiving_object_tips:'选择您的目标用户，这些用户将通过商脉圈查看到您发的需求信息',
  receiving_object_tips2: '选择展商类别，这些展商将收到您的商脉圈消息',
  requirement_content: '需求内容',
  upload_pictures_or_videos: '图片或视频',
  upload_desc: '图片和视频不能同时上传',
  published_successfully: '发布成功',
  comment: '评论',
  like: '喜欢',
  op_invitation: '邀约',
  reply: '回复',
  // release_requirements: '发布需求',
  release_requirements: '发布商脉圈',
  my_releases: '商脉圈管理',
  please_select: '请选择',
  select_exhibits_title: '请选择类别',
  select_receiving_alter: '请选择接收对象',
  opportunity_management: '商机管理',
  op_publish: '发布',
  "Your publisher's cycle count has reached its limit":"您的发布商脉圈次数已达上限",
  uploadTips_1: '1.图片为正方形，支持png、jpg格式，不超过1Mb，您可以最多上传九张',
  uploadTips_2: '2.视频支持mp4格式，不超过100Mb，您可以上传一个视频和一个视频封面',
  uploadTips_3: '3.上传视频将清空已上传的图片',
  uploadTips_4: '共',
  uploadTips_5: '张',
  uploadTips_6: '还可以上传',
  'Notice': '注意：',
  'Upload picture': '上传图片'
}